import { EventEmitter, TemplateRef } from "@angular/core";
import { BaseComponent } from '../base.component';
import { CoachDetails } from '../model/coach-details.model';
import { SessionStorageService } from "ngx-webstorage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment";
import { Router } from "@angular/router";
import * as i0 from "@angular/core";
import * as i1 from "ngx-webstorage";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "@angular/router";
import * as i4 from "@angular/common";
import * as i5 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i6 from "../upload-image-component/profile-image.component";
import * as i7 from "../badge/badge.component";
import * as i8 from "../../entities/session/schedule-session/supported-languages/supported-languages.component";
import * as i9 from "@fortawesome/angular-fontawesome";
import * as i10 from "../alert/alert-error.component";
import * as i11 from "../coach-bio/coach-bio.component";
import * as i12 from "../language/find-language-from-key.pipe";
const _c0 = ["coachBioModal"];
const _c1 = function (a0) { return { language: a0 }; };
function CoachCardComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelement(2, "img", 7);
    i0.ɵɵelement(3, "p", 8);
    i0.ɵɵpipe(4, "findLanguageFromKey");
    i0.ɵɵelementStart(5, "a", 9);
    i0.ɵɵlistener("click", function CoachCardComponent_div_1_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.showChatOptions(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(3, _c1, i0.ɵɵpipeBind1(4, 1, ctx_r0.selectedLanguages.toString())));
} }
function CoachCardComponent_div_2_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "badge-component", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coachDetails", ctx_r11.coachDetails);
} }
function CoachCardComponent_div_2_div_2_supported_languages_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "supported-languages", 33);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("list", ctx_r12.coachLanguages);
} }
const _c2 = function () { return ["en"]; };
function CoachCardComponent_div_2_div_2_supported_languages_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "supported-languages", 33);
} if (rf & 2) {
    i0.ɵɵproperty("list", i0.ɵɵpureFunction0(1, _c2));
} }
const _c3 = function () { return []; };
function CoachCardComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵelementStart(2, "div", 16);
    i0.ɵɵlistener("click", function CoachCardComponent_div_2_div_2_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.displayCoachBio(ctx_r14.coach); });
    i0.ɵɵelement(3, "profile-image", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 18);
    i0.ɵɵelementStart(5, "div", 19);
    i0.ɵɵelementStart(6, "h4", 20);
    i0.ɵɵlistener("click", function CoachCardComponent_div_2_div_2_Template_h4_click_6_listener() { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.displayCoachBio(ctx_r16.coach); });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, CoachCardComponent_div_2_div_2_div_8_Template, 2, 1, "div", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 21);
    i0.ɵɵlistener("click", function CoachCardComponent_div_2_div_2_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r15); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.displayCoachBio(ctx_r17.coach); });
    i0.ɵɵelementStart(10, "ngb-rating", 22);
    i0.ɵɵlistener("rateChange", function CoachCardComponent_div_2_div_2_Template_ngb_rating_rateChange_10_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.coach.coachScore = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 23);
    i0.ɵɵelementStart(12, "u", 24);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 25);
    i0.ɵɵlistener("click", function CoachCardComponent_div_2_div_2_Template_div_click_15_listener() { i0.ɵɵrestoreView(_r15); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.displayCoachBio(ctx_r19.coach); });
    i0.ɵɵtemplate(16, CoachCardComponent_div_2_div_2_supported_languages_16_Template, 1, 1, "supported-languages", 26);
    i0.ɵɵtemplate(17, CoachCardComponent_div_2_div_2_supported_languages_17_Template, 1, 2, "supported-languages", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 27);
    i0.ɵɵlistener("click", function CoachCardComponent_div_2_div_2_Template_div_click_18_listener() { i0.ɵɵrestoreView(_r15); const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.displayCoachBio(ctx_r20.coach); });
    i0.ɵɵelementStart(19, "div", 28);
    i0.ɵɵelementStart(20, "span", 29);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 30);
    i0.ɵɵelement(23, "button", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    const _r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("coachId", ctx_r8.coach.id)("coachLogin", ctx_r8.coach.login)("videoEnabled", ctx_r8.coachDetails.videoChatEnabled)("coachDetails", ctx_r8.coachDetails)("size", 64)("smallIconSize", true);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r8.coach.login);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.coachDetails);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("rate", ctx_r8.coach.coachScore)("starTemplate", _r2)("readonly", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(14, 15, ctx_r8.coach.coachScore, "1.0-1"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r8.coachLanguages != null && ctx_r8.coachLanguages != i0.ɵɵpureFunction0(18, _c3));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.coachLanguages === null || ctx_r8.coachLanguages === undefined || ctx_r8.coachLanguages === i0.ɵɵpureFunction0(19, _c3));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate("\"" + ctx_r8.getCoachReasoning() + "\"");
} }
const _c4 = function (a0, a1) { return { date: a0, time: a1 }; };
function CoachCardComponent_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "p", 35);
    i0.ɵɵelementStart(2, "button", 36);
    i0.ɵɵlistener("click", function CoachCardComponent_div_2_div_4_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.bookASession(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(1, _c4, ctx_r9.getDate(ctx_r9.earliestAvailableTime), ctx_r9.getTime(ctx_r9.earliestAvailableTime)));
} }
function CoachCardComponent_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "span", 37);
    i0.ɵɵelement(2, "span", 38);
    i0.ɵɵelement(3, "span", 39);
    i0.ɵɵelementStart(4, "a", 40);
    i0.ɵɵlistener("click", function CoachCardComponent_div_2_div_5_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.customerCare(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CoachCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtemplate(2, CoachCardComponent_div_2_div_2_Template, 24, 20, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "hr", 12);
    i0.ɵɵtemplate(4, CoachCardComponent_div_2_div_4_Template, 3, 4, "div", 13);
    i0.ɵɵtemplate(5, CoachCardComponent_div_2_div_5_Template, 5, 0, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.coach != null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.earliestAvailableTime != null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.earliestAvailableTime === null || ctx_r1.earliestAvailableTime === undefined);
} }
const _c5 = function () { return ["fas", "star"]; };
const _c6 = function () { return ["far", "star"]; };
function CoachCardComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵelementStart(1, "span", 42);
    i0.ɵɵelementStart(2, "em", 43);
    i0.ɵɵelement(3, "fa-icon", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "em", 45);
    i0.ɵɵelement(5, "fa-icon", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const fill_r25 = ctx.fill;
    i0.ɵɵclassProp("full", fill_r25 === 100);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", fill_r25, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(6, _c5));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(7, _c6));
} }
function CoachCardComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "fa-icon", 47);
    i0.ɵɵlistener("click", function CoachCardComponent_ng_template_5_Template_fa_icon_click_1_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 48);
    i0.ɵɵelement(3, "jhi-alert-error");
    i0.ɵɵelement(4, "coach-bio", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("coach", ctx_r5.coachBioCoach)("selectedCoachReasoning", ctx_r5.coachBioReasoning);
} }
export class CoachCardComponent extends BaseComponent {
    constructor(sessionStorage, modalService, router) {
        super(sessionStorage, modalService);
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.router = router;
        this.onCoachSelected = new EventEmitter();
        this.onChatOptionSelected = new EventEmitter();
    }
    set coach(value) {
        this._coach = value;
    }
    get coach() {
        return this._coach;
    }
    set coachDetails(value) {
        this._coachDetails = value;
    }
    get coachDetails() {
        return this._coachDetails;
    }
    ngOnInit() {
        var _a;
        this.coachLanguages = (_a = this.coachReasoningList) === null || _a === void 0 ? void 0 : _a.map(cr => cr.lang);
    }
    displayCoachBio(coach) {
        this.coachBioCoach = coach;
        this.coachBioReasoning = this.coachReasoningList.find(cr => this.selectedLanguages.includes(cr.lang));
        this.modalService.open(this.coachBioModal, { size: 'lg', backdrop: 'static', centered: true });
    }
    getCoachReasoning() {
        let coachReasoning = this.coachReasoningList.find(cr => this.selectedLanguages.includes(cr.lang));
        return coachReasoning != null ? coachReasoning.coachReasoningText : "";
    }
    getDate(dateTime) {
        return moment(dateTime).format('DD MMM');
    }
    getTime(dateTime) {
        return moment(dateTime).format('hh:mm a');
    }
    bookASession() {
        let commonList = [];
        for (let i = 0; i < this.coachLanguages.length; i++) {
            if (this.selectedLanguages.includes(this.coachLanguages[i])) {
                if (!commonList.includes(this.coachLanguages[i]))
                    commonList.push(this.coachLanguages[i]);
            }
        }
        for (let i = 0; i < this.selectedLanguages.length; i++) {
            if (this.coachLanguages.includes(this.selectedLanguages[i])) {
                if (!commonList.includes(this.selectedLanguages[i]))
                    commonList.push(this.selectedLanguages[i]);
            }
        }
        let params = {
            coachId: this.coach.id,
            sessionType: this.selectedSessionType,
            sessionLanguage: commonList
        };
        if (this.selectedSessionDuration) {
            params['duration'] = this.selectedSessionDuration;
        }
        this.router.navigate(['/schedule-session'], { queryParams: params }).then();
        this.modalService.dismissAll();
    }
    customerCare() {
        this.router.navigate(['/session/inbox/customer-care']).then();
    }
    showChatOptions() {
        this.onChatOptionSelected.emit(['text']);
    }
    close() {
        this.modalService.dismissAll();
    }
}
CoachCardComponent.ɵfac = function CoachCardComponent_Factory(t) { return new (t || CoachCardComponent)(i0.ɵɵdirectiveInject(i1.SessionStorageService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.Router)); };
CoachCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CoachCardComponent, selectors: [["coach-card"]], viewQuery: function CoachCardComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.coachBioModal = _t.first);
    } }, inputs: { coach: "coach", coachDetails: "coachDetails", coachReasoningList: "coachReasoningList", earliestAvailableTime: "earliestAvailableTime", selectedSessionType: "selectedSessionType", selectedLanguages: "selectedLanguages", selectedSessionDuration: "selectedSessionDuration", showChatOptionCard: "showChatOptionCard" }, outputs: { onCoachSelected: "onCoachSelected", onChatOptionSelected: "onChatOptionSelected" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 2, consts: [[1, "olha-theme", "bg-white", "coach-card"], ["class", "d-flex justify-content-center align-items-center", "style", "flex-direction: column", 4, "ngIf"], [4, "ngIf"], ["t", ""], ["coachBioModal", ""], [1, "d-flex", "justify-content-center", "align-items-center", 2, "flex-direction", "column"], [2, "margin", "60px auto 20px auto"], ["src", "../../../../content/images/dialog-bubble.svg", "alt", "dialog-bubble", 1, "light-bulb-image"], ["jhiTranslate", "sessionSchedule.checkThem", 2, "margin", "20px 50px!important", 3, "translateValues"], ["jhiTranslate", "sessionSchedule.showChatOptions", 1, "btn-link", 2, "margin", "20px 50px!important", 3, "click"], [2, "cursor", "pointer"], ["style", "padding: 20px 20px 0 20px;  flex-direction: column", "class", "d-flex justify-content-start align-items-start", 4, "ngIf"], [2, "width", "88%!important", "border", "1px solid #44A38B!important"], ["class", "d-flex justify-content-center align-items-center", "style", "position: absolute; bottom: 20px; flex-direction: column; width: 100%", 4, "ngIf"], [1, "d-flex", "justify-content-start", "align-items-start", 2, "padding", "20px 20px 0 20px", "flex-direction", "column"], [1, "d-flex", "justify-content-start", "align-items-start", "mb-4"], [1, "coach-image-div", 3, "click"], [3, "coachId", "coachLogin", "videoEnabled", "coachDetails", "size", "smallIconSize"], [1, "coach-name-div"], [1, "coach-header-div"], [1, "coach-header", 3, "click"], [1, "mb-1", "d-flex", "justify-content-start", "align-items-center", 3, "click"], ["max", "5", 3, "rate", "starTemplate", "readonly", "rateChange"], [1, "px-2"], [2, "text-decoration", "none"], [3, "click"], [3, "list", 4, "ngIf"], [1, "d-flex", "justify-content-start", "align-items-center", 2, "overflow", "clip", "position", "relative", "width", "100%", 3, "click"], [2, "background", "white", "text-align", "start!important", "max-height", "66px"], [1, "text"], [1, "pl-1", 2, "position", "absolute", "right", "3px", "bottom", "-3px", "z-index", "1000", "background", "white"], ["jhiTranslate", "sessionSchedule.button.readMore", 1, "btn", "btn-link"], [3, "coachDetails"], [3, "list"], [1, "d-flex", "justify-content-center", "align-items-center", 2, "position", "absolute", "bottom", "20px", "flex-direction", "column", "width", "100%"], ["jhiTranslate", "sessionSchedule.firstAvailableSlot", 1, "first-available", 3, "translateValues"], ["jhiTranslate", "inukaNgApp.indexUser.bookASession", 1, "btn", "btn-primary", "m-2", "button-primary", 3, "click"], ["jhiTranslate", "sessionSchedule.noAvailableSlot", 1, "first-available"], ["jhiTranslate", "sessionSchedule.needToSchedule"], ["jhiTranslate", "sessionSchedule.hereForYou"], ["jhiTranslate", "sessionSchedule.customerCare", 1, "btn-link", 3, "click"], [1, "star"], [1, "half"], [2, "color", "#44A38D"], [3, "icon"], [1, "cursor", 2, "color", "#44A38D"], [1, "olha-theme", "p-4", "coach-bio"], ["icon", "times-circle", 1, "close", 3, "click"], [1, "main-body"], [3, "coach", "selectedCoachReasoning"]], template: function CoachCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CoachCardComponent_div_1_Template, 6, 5, "div", 1);
        i0.ɵɵtemplate(2, CoachCardComponent_div_2_Template, 6, 3, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, CoachCardComponent_ng_template_3_Template, 6, 8, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, CoachCardComponent_ng_template_5_Template, 5, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showChatOptionCard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showChatOptionCard);
    } }, directives: [i4.NgIf, i5.JhiTranslateDirective, i6.ProfileImageComponent, i2.NgbRating, i7.BadgeComponent, i8.SupportedLanguagesComponent, i9.FaIconComponent, i10.AlertErrorComponent, i11.CoachBioComponent], pipes: [i12.FindLanguageFromKeyPipe, i4.DecimalPipe], styles: [".coach-card[_ngcontent-%COMP%]:hover{box-shadow:0 10px 20px 0 rgba(0,0,0,.13)}.coach-bio[_ngcontent-%COMP%]{min-height:600px;max-height:800px}.coach-card[_ngcontent-%COMP%]{border-radius:20px;margin:20px;height:360px;width:348px;position:relative}.coach-header-div[_ngcontent-%COMP%]{color:var(--text-dark-green, #0A4A3A);font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:600;line-height:130%}.coach-name-div[_ngcontent-%COMP%]{padding-left:10px}.star[_ngcontent-%COMP%]{position:relative;display:inline-block;font-size:1rem}.half[_ngcontent-%COMP%]{position:absolute;display:inline-block;overflow:hidden}.badge[_ngcontent-%COMP%]{background:rgba(68,163,141,.1);color:#44a38b;border-radius:16px;padding:1px 20px;width:120px;height:30px;margin:10px}.text[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-family:Open Sans,serif;font-size:14px;font-style:normal;font-weight:400;line-height:160%;text-align:start !important}.coach-header[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-family:Poppins,serif;font-size:16px;font-style:normal;font-weight:600;line-height:130%;margin-bottom:0 !important;text-align:left}.first-available[_ngcontent-%COMP%]{color:var(--Text-Green-Light-Text, #9DB7B0);text-align:center;font-family:Open Sans,serif;font-size:14px;font-style:normal;font-weight:400;line-height:140%}"] });
